import React from 'react';
import PropTypes from 'prop-types';
import styles from './Popup.module.scss';

const Popup = ({show, children, closeHandler, styleOverride}) => {

    if (!show) {
        return null;
    }

    const containerClasses = [styles.popupContainer];

    return (
        <div className={containerClasses.join(' ')} style={styleOverride}>
            <i className={[styles.closeBtn, 'icon-sata-close-icon'].join(' ')}
               aria-hidden={true}
               onClick={closeHandler}/>
            {children}
        </div>
    );
};

Popup.propTypes = {
    show: PropTypes.bool,
    children: PropTypes.any,
    closeHandler: PropTypes.func,
    styleOverride: PropTypes.object,
};

Popup.defaultProps = {
    show: true,
    children: null,
    closeHandler: PropTypes.func,
    styleOverride: {},
};

export default Popup;
